"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = DeleteButton;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_native_1 = require("react-native");
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const pro_regular_svg_icons_1 = require("@fortawesome/pro-regular-svg-icons");
const colors_1 = require("../../../common/colors");
function DeleteButton({ style, ...restProps }) {
    return ((0, jsx_runtime_1.jsx)(react_native_1.Pressable, { style: (pressed) => [styles.container, typeof style === 'function' ? style(pressed) : style], ...restProps, children: (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: pro_regular_svg_icons_1.faTrash, color: colors_1.Colors.NEUTRAL_25, size: 14 }) }));
}
;
const styles = react_native_1.StyleSheet.create({
    container: {
        backgroundColor: 'rgba(62, 62, 66, 0.50)',
        padding: 9,
        borderRadius: 56,
    },
});
